export type FlightView = 'stats' | 'history' | 'airports' | 'selections';

export const FLIGHT_VIEW_PATHS: Record<FlightView, string> = {
  stats: '/flights',
  history: '/flights/history',
  airports: '/flights/airports',
  selections: '/flights/selected',
};

export function flightViewForPath(pathname: string): FlightView {
  const normalized = pathname.replace(/\/+$/, '');
  const match = (Object.keys(FLIGHT_VIEW_PATHS) as FlightView[]).find(
    (view) => FLIGHT_VIEW_PATHS[view] === normalized
  );
  return match ?? 'stats';
}

export function isFlightsPath(pathname: string): boolean {
  return pathname === '/flights' || pathname.startsWith('/flights/');
}

/**
 * Old links chose the tab with ?view=. /flight-tracker opened the personal log;
 * /ssss and the other old names opened the selection map.
 */
export function legacyFlightsPath(
  search: string,
  hash: string,
  defaultView: FlightView
): string {
  const params = new URLSearchParams(search);
  const requested = params.get('view');
  params.delete('view');
  let view = defaultView;
  if (requested === 'airports' || requested === 'selections') view = requested;
  const query = params.toString();
  return `${FLIGHT_VIEW_PATHS[view]}${query ? `?${query}` : ''}${hash}`;
}
